import React, { SVGAttributes } from "react";

const Transfer: React.FC<SVGAttributes<any>> = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
      <path d="M4.13025 18.8842H28.7802" stroke="currentColor" stroke-opacity="0.8" stroke-width="2.61001" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M33.13 20.4936C33.13 24.4086 32.2165 25.6701 28.78 25.8731V15.5056C28.78 11.1846 27.678 10.0971 23.299 10.0971H9.61108C9.20508 10.0971 8.82804 10.1116 8.48004 10.1261C8.52354 5.99358 9.65458 4.94958 13.9611 4.94958H27.649C32.028 4.94958 33.13 6.03708 33.13 10.3581V20.4936Z"
        stroke="#FFBE40"
        stroke-width="2.61001"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M28.7802 25.8731C28.7367 30.0056 27.6057 31.0496 23.2992 31.0496H9.61129C5.23229 31.0496 4.13025 29.9621 4.13025 25.6411V15.5056C4.13025 11.5906 5.04375 10.3291 8.48025 10.1261C8.82825 10.1116 9.20529 10.0971 9.61129 10.0971H23.2992C27.6782 10.0971 28.7802 11.1846 28.7802 15.5056V25.8731Z"
        stroke="currentColor"
        stroke-opacity="0.8"
        stroke-width="2.61001"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M8.84326 26.424H11.3372" stroke="currentColor" stroke-opacity="0.8" stroke-width="2.61001" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M14.4396 26.424H19.4276" stroke="currentColor" stroke-opacity="0.8" stroke-width="2.61001" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
};

export default Transfer;
